import * as Pipeline from '../global/pipeline';

/**
 * Add a component to the ADS pipeline
 * @param  {HTMLElement} component   The component element
 * @return {void}
 */
export const addComponent = (component: HTMLElement): void => {
  Pipeline.add(component);
};

/**
 * Remove a component from the ADS pipeline
 * @param  {HTMLElement} component   The component element
 * @return {void}
 */
export const removeComponent = (component: HTMLElement): void => {
  Pipeline.remove(component);
};
